import { render, staticRenderFns } from "./ManageFrame.vue?vue&type=template&id=cea97350&scoped=true&"
import script from "./ManageFrame.vue?vue&type=script&lang=js&"
export * from "./ManageFrame.vue?vue&type=script&lang=js&"
import style0 from "./ManageFrame.vue?vue&type=style&index=0&id=cea97350&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cea97350",
  null
  
)

export default component.exports